import React, { useContext } from 'react';
import EditTextField from 'shared/lib/components/controls/textFields/editTextField';
import { CustomTextFieldProps } from 'shared/lib/components/controls/textFields/customTextField';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { InputBaseComponentProps } from '@mui/material';

export default function EditableTableCellItem({
  isEditIcon,
  error,
  textColor,
  multiline = true,
  inputProps,
  ...other
}: {
  isEditIcon?: boolean;
  error?: boolean;
  textColor?: string;
  multiline?: boolean;
  inputProps?: Partial<InputBaseComponentProps>;
} & CustomTextFieldProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const redefineInputProps = isEditIcon ? {} : { InputProps: {} };

  return (
    <EditTextField
      multiline={multiline}
      variant="outlined"
      wrapperSxProps={{ height: 1 }}
      inputProps={inputProps}
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          display: 'none',
        },
        '& .MuiInputBase-root': {
          color: error ? 'error.main' : textColor,
          p: sp.s30,
        },
      }}
      {...redefineInputProps}
      {...other}
    ></EditTextField>
  );
}
